// @flow

export type Pixels = {
  x: number,
  y: number,
  width: number,
  height: number
}

export type Crop = {
  x: number,
  y: number
}

export type Action = {
  type: string,
  zoom?: number,
  crop?: Crop,
  pixels?: Pixels,
  modal?: boolean,
  image?: string,
  imageSrc?: string
}

type State = {
  imageSrc: string,
  crop: Crop,
  zoom: number,
  image: string,
  modal: boolean,
  pixels: Pixels
}

const initialState: State = {
  imageSrc: '',
  crop: { x: 0, y: 0 },
  zoom: 1,
  image: '',
  modal: false,
  pixels: { x: 0, y: 0, width: 0, height: 0 },
};

function app(state: State = initialState, action: Object): State {
  switch (action.type) {
    case 'ZOOM':
      return { ...state, zoom: action.zoom };
    case 'OPEN':
      return { ...state, modal: true };
    case 'CLOSE':
      return { ...state, modal: false };
    case 'CROP':
      return { ...state, crop: action.crop };
    case 'COMPLETE':
      return { ...state, pixels: action.pixels };
    case 'RENDER':
      return { ...state, image: action.image, modal: false };
    case 'SHOW_CROP':
      return {
        ...state,
        imageSrc: action.image,
        crop: { x: 0, y: 0 },
        zoom: 1,
        modal: true,
      };
    default:
      return state;
  }
}

export default app;
